import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const labelClass = ['text-sm', 'font-bold', 'truncate'];
const valueClass = ['mt-1', 'text-3xl', 'font-bold'];
function getLabelClass(color = 'gray') {
    switch (color) {
        case 'green':
            return [...labelClass, 'text-green-500'];
        case 'blue':
            return [...labelClass, 'text-blue-500'];
        case 'red':
            return [...labelClass, 'text-red-500'];
        case 'yellow':
            return [...labelClass, 'text-yellow-500'];
        default:
            return [...labelClass, 'text-grey-darker'];
    }
}
function getValueClass(color = 'gray') {
    let className;
    switch (color) {
        case 'green':
            className = [...valueClass, 'text-green-500'];
            break;
        case 'blue':
            className = [...valueClass, 'text-blue-500'];
            break;
        case 'red':
            className = [...valueClass, 'text-red-500'];
            break;
        case 'yellow':
            className = [...valueClass, 'text-yellow-500'];
            break;
        default:
            className = [...valueClass, 'text-grey-darker'];
    }
    return classnames(className);
}
function getClassName(className) {
    if (typeof className === 'undefined') {
        return '';
    }
    if (typeof className === 'string') {
        return classnames(...className.split(' '));
    }
    if (Array.isArray(className)) {
        return classnames(...className);
    }
    return classnames(className);
}
const StatHeading = ({ label, value, color, className, dataTestId }) => (React.createElement("div", { "data-testid": dataTestId, className: getClassName(className) },
    React.createElement("dt", { "data-testid": "dt-d7a46176", className: classnames(getLabelClass('gray')) }, label),
    React.createElement("dd", { "data-testid": "dd-47d632b3", className: getValueClass(color) }, value)));
StatHeading.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    color: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
};
StatHeading.defaultProps = {
    color: 'gray',
};
export default StatHeading;
